module.exports = __webpack_public_path__ + "img/search-active-icon.5f818131.svg";